import { render, staticRenderFns } from "./Doctorph.vue?vue&type=template&id=25b41239&"
import script from "./Doctorph.vue?vue&type=script&lang=js&"
export * from "./Doctorph.vue?vue&type=script&lang=js&"
import style0 from "./Doctorph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports